import { Injectable } from "@angular/core";
import { FormisForm, MCEnvironmentsService, SectionSchema, Store } from "@maslul/common-services";
import { FormlyFieldConfig } from "@ngx-formly/core";
import { Observable } from "rxjs";

export class GeneralDetailsStoreData {

    formisForm: FormisForm | undefined;
    formisFormModel: any;
    formisFormFields: Array<FormlyFieldConfig> | undefined;
    fieldsSchema: Array<SectionSchema> | undefined;
}
const GENERAL_DETAILS: GeneralDetailsStoreData =
{
    formisForm: undefined,
    formisFormModel: {},
    formisFormFields: undefined,
    fieldsSchema: undefined
}

@Injectable({
    providedIn: 'root',
})
export class GeneralDetailsStore extends Store<GeneralDetailsStoreData> {

    constructor(protected override environmentsService: MCEnvironmentsService) {
        super('', GENERAL_DETAILS, environmentsService);
    }


    getFormisForm(): Observable<FormisForm | undefined> {
        return this.select(s => s.formisForm);
    }

    setFormisForm(formisForm: FormisForm) {
        this.updateState('[GeneralDetails Store Service] set formisForm', { formisForm })
    }

    getFormisFormModel(): Observable<any> {
        return this.select(s => s.formisFormModel);
    }

    setFormisFormModel(formisFormModel: any) {
        this.updateState('[GeneralDetails Details Store Service] set formisForm model', { formisFormModel: formisFormModel })
    }

    getFormisFormFields(): Observable<Array<FormlyFieldConfig> | undefined> {
        return this.select(s => s.formisFormFields);
    }

    setFormisFormFields(formisFormFields: Array<FormlyFieldConfig>) {
        this.updateState('[GeneralDetails Details Store Service] set formisForm Fields', { formisFormFields: formisFormFields })
    }

    getFieldsSchema(): Observable<Array<SectionSchema> | undefined> {
        return this.select(s => s.fieldsSchema);
    }

    setFieldsSchema(fieldsSchema: Array<SectionSchema>) {
        this.updateState('[GeneralDetails Details Store Service] set fieldsSchema', { fieldsSchema: fieldsSchema })
    }
}